"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.compact = void 0;
var isEmpty_1 = require("./isEmpty");
var compact = function (obj) {
    if (obj instanceof Array) {
        return obj.filter(function (value) { return !isEmpty_1.isEmpty(value); });
    }
    if (obj instanceof Object) {
        return Object.entries(obj).reduce(function (acc, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (isEmpty_1.isEmpty(value) ? acc : __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
        }, {});
    }
    return obj;
};
exports.compact = compact;
//# sourceMappingURL=compact.js.map